/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-06-24 10:59:11
 * @LastEditors: changfeng
 * @LastEditTime: 2024-07-02 17:34:50
 */
// 全局共享数据示例

const global = () => {
  let token: string = '';

  const setToken = (value: string) => {
    token = value;
    localStorage.setItem('Authorization', value);
  };

  return {
    token,
    setToken,
  };
};

export default global;
